import { VERTICAL_EMBED_TYPE } from "./../../ricos-content";
import VerticalSearchModule from "./VerticalSearchModule";
function verticalEmbedEditorStrategy(instance, hasPlugin) {
  if (!instance || !hasPlugin(VERTICAL_EMBED_TYPE)) {
    return {
      config: {}
    };
  }
  return {
    config: {
      [VERTICAL_EMBED_TYPE]: {
        verticalsApi: (type, locale = "en") => new VerticalSearchModule(type, instance, locale),
        getIsVisiblePromise: (type, locale = "en") => new VerticalSearchModule(type, instance, locale).isInstalled()
      }
    }
  };
}
export {
  verticalEmbedEditorStrategy
};
//# sourceMappingURL=verticalEmbedEditorStrategy.js.map
